import React, { useState } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow,Button } from "@mui/material";
import BuildingCheckInHistoryModal from "./BuildingCheckInHistoryModal";




const MonthlyCheckIn = ({ buildings, fetchFacilitiesAndBuildings }) => {
    const [selectedBuilding, setSelectedBuilding] = useState(null); // To store the selected building
    //console.log(selectedBuilding)
    const [openModal, setOpenModal] = useState(false); // To control modal visibility
    const [reportData, setReportData] = useState(null);

    const handleRowClick = (building) => {
        setSelectedBuilding(building); // Set the clicked building
        setOpenModal(true); // Open the modal
    };

    const handleCloseModal = () => {
        setOpenModal(false); // Close the modal
        setSelectedBuilding(null);
        fetchFacilitiesAndBuildings();
    };

    return (
        <Box>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Legal Name</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Zip Code</TableCell>
                        <TableCell>Last Successful Check In</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {buildings.map((building, index) => (
                        <TableRow
                            key={index}
                            onClick={() => handleRowClick(building)}
                            style={{ cursor: "pointer" }} // Add pointer cursor for better UX
                        >
                            <TableCell>{building.legal_name}</TableCell>
                            <TableCell>{building.address1}</TableCell>
                            <TableCell>{building.state}</TableCell>
                            <TableCell>{building.zip_code}</TableCell>
                            <TableCell>
                                {building.lastcheckin
                                    ? (() => {
                                        const dateObj = new Date(building.lastcheckin);
                                        if (isNaN(dateObj.getTime())) return "Unknown"; // Handle invalid dates

                                        const options = {
                                            month: "2-digit",
                                            day: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true
                                        };
                                        return dateObj.toLocaleString("en-US", options);
                                    })()
                                    : "Unknown"}
                            </TableCell>


                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {/* Render the modal */}
            {selectedBuilding && (
                <BuildingCheckInHistoryModal
                    open={openModal}
                    onClose={handleCloseModal}
                    building={selectedBuilding}
                />
            )}


        </Box>
    );
};

export default MonthlyCheckIn;
